// apis.ts
import fetch from 'services/request';
import {
  EmailSMSRequest,
  GetTicketListParams,
  GetTicketSummaryParams,
  RefundTicketRequest,
  UpdateTicketRequest,
  VoidTicketRequest,
} from './types';

const API_V1 = '/api/v1';
const BILL_BASE_URL = `${API_V1}/bill`;
const PAYMENRT_BASE_URL = `${API_V1}/payment`;

const apiTickets = {
  get: {
    summary: (params: GetTicketSummaryParams) =>
      fetch({
        method: 'get',
        url: `${BILL_BASE_URL}/summary-tickets`,
        params,
      }),
    newTicket: () =>
      fetch({
        method: 'get',
        url: `${BILL_BASE_URL}/new-ticket`,
      }),
    list: (params: GetTicketListParams) =>
      fetch({
        method: 'get',
        url: `${BILL_BASE_URL}/list-ticket`,
        params: {
          ...params,
          page: params.page ?? 1,
        },
      }),
    onHold: () =>
      fetch({
        method: 'get',
        url: `${BILL_BASE_URL}/list-on-hold`,
      }),
    detail: (billId: string) =>
      fetch({
        method: 'get',
        url: `${BILL_BASE_URL}/detail/${billId}`,
      }),
  },
  post: {
    update: (payload: UpdateTicketRequest) =>
      fetch({
        method: 'post',
        url: `${BILL_BASE_URL}/update-ticket`,
        body: payload,
      }),
    refund: (payload: RefundTicketRequest) =>
      fetch({
        method: 'post',
        url: `${PAYMENRT_BASE_URL}/refund-ticket`,
        body: payload,
      }),
    void: (payload: VoidTicketRequest) =>
      fetch({
        method: 'post',
        url: `${PAYMENRT_BASE_URL}/voided-ticket`,
        body: payload,
      }),
    emailSms:  (payload: EmailSMSRequest) =>
      fetch({
        method: 'post',
        url: `${PAYMENRT_BASE_URL}/send-sms-email-receipt`,
        body: payload,
      }),
  },
};
export default apiTickets;
